export default {"src":"/_next/static/media/bob-ross.5c5fecad.gif","height":252,"width":336,"blurWidth":0,"blurHeight":0};